import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import { AppState } from '../../../store';
import config from '../../../config';

import DocumentTypeCreate from '../screens/create';
import DocumentTypeList from '../screens/list';
import NotFound from '../../not-found/';

const Routes: React.FC = () => {
  const authType: string = useSelector((state: AppState) => state.Authorization.authType);
  const publicUrl = process.env.PUBLIC_URL;

  if (authType) {
    return (
      <>
        <Route path={`${publicUrl}/document-type/create`} exact component={authType === config.userTypeAdmin ? DocumentTypeCreate : NotFound } />
        <Route path={`${publicUrl}/document-type/edit/:id`} exact component={authType === config.userTypeAdmin ? DocumentTypeCreate : NotFound } />
        <Route path={`${publicUrl}/document-type/list`} exact component={authType === config.userTypeAdmin ? DocumentTypeList : NotFound } />
      </>
    )
  } else {
    return null;
  }
}

export default Routes;